<template>
  <div class="container" v-if="list.length > 0">
    <div v-for="(item, index) in list" :key="index" class="itemBox">
      <div class="appimg" @click="openUrl(item.url)">
        <cjImg :src="_getImgUrl(item.img)" objectFit="contain" :autoHeight="true" class="img" alt="" />
        <div class="corner">
          <div class="name">{{ `价格:${item.minPrice || 0}-${item.maxPrice || 0}` }}</div>
          <div class="des">{{ item.name }}</div>
        </div>
        <div class="topNum">
          {{ `${item.useNum || 0}人约过` }}
        </div>
        <div class="background_box"></div>
        <!-- <span class="corner">{{ `更新至${item.update}画` }}</span> -->
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { getImgUrl } from '@/utils/tools'
import { Toast } from 'vant'
export default {
  name: 'nomalTwo',
  components: {},
  props: {
    source: Array,
    _getImgUrl: Function
  },
  watch: {
    source: {
      handler(nv) {
        console.log('', '', '===>', '*', nv)
        if (nv.length > 0) {
          // const evenIndices = nv.filter((_, index) => index % 2 === 0)
          // const oddIndices = nv.filter((_, index) => index % 2 !== 0)
          // console.log(evenIndices,oddIndices,'oddIndices')
          // this.list =  [...evenIndices,...oddIndices]
          this.list = nv
        }
      },
      deep: true
      // immediate: true
    }
  },
  data() {
    return {
      list: []
    }
  },
  async created() {},
  methods: {
    openUrl(link) {
      if (!link) {
        return 
      }
      console.log(link, 'linklink')
      const regx = /^(http(s?)|tmast|appmarket|vivoMarket|mimarket|anzhimarket|mstore|samsungapps):\/\//gi
      if (!link.match(regx)) {
        // window.open(`https://${adObj.link}`, adObj.name)
        Toast.fail('访问地址异常')
      } else {
        let a = document.createElement('a')
        a.style = 'display: none' // 创建一个隐藏的a标签
        a.download = ''
        a.href = link
        document.body.appendChild(a)
        a.click() // 触发a标签的click事件
        document.body.removeChild(a)
        // window.open(link)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container::after {
  content: '';
  display: block;
  width: 100%;
  height: 3px; /* 微小高度，修复空白 */
  background: transparent;
}
.container {
  -webkit-column-count: 2;  /* 兼容写法 */
  column-count: 2;
  -webkit-column-gap:10px;  /* 必须添加前缀 */
  column-gap:10px;
  -webkit-column-fill: balance; /* Safari 专用修复 */
  .itemBox {
    page-break-inside: avoid;
  -webkit-column-break-inside: avoid;  /* Safari 兼容 */
    break-inside: avoid; /* 防止元素被分割到不同列 */
    margin-bottom: 10px;
    .name_des {
      margin-top: 5px;
      font-family: PingFangSC-Semibold;
      font-size: 13px;
      color: #ffffff;
      letter-spacing: -0px;
      font-weight: 600;
      text-align: left;
    }
  }
  .appimg {
    min-height: 50px;
    width: 100%;
    height: auto;
    position: relative;
    border-radius: 5.22px;
    .topNum {
      background: #ff5388;
      border-radius: 0px 100px 100px 0px;
      font-family: PingFangSC-Medium;
      font-size: 11px;
      color: #ffffff;
      letter-spacing: -0px;
      font-weight: 500;
      padding: 1px 7px;
      position: absolute;
      top: 6px;
    }
    .img {
      width: 100%;
      height: 100px;
      min-height: 30px;
      border-radius: 5.22px;
      display: block;
      object-fit: cover;
    }
    .background_box{
      height: 46px;
      width: 100%;
      bottom: 0;
      right: 0;
      position: absolute;
      background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.50) 100%);
    }
    .corner {
      position: absolute;
      left: 8px;
      bottom: 4px;
      width: 100%;
      text-align: left;
      .name {
        font-family: PingFangSC-Semibold;
        font-size: 13px;
        color: #ffffff;
        letter-spacing: -0px;
        font-weight: 600;
      }
      .des {
        font-family: PingFangSC-Regular;
        font-size: 11px;
        color: rgba(255, 255, 255, 0.8);
        letter-spacing: -0px;
        font-weight: 400;
        width: calc(100% - 8px);
        overflow: hidden; /* 隐藏溢出内容 */
        text-overflow: ellipsis; /* 显示省略号 */
        white-space: nowrap; /* 禁止换行 */
      }
    }
  }
}
</style>
